import { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { auth, db } from '../../lib/firebase';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import LoadingScreen from '../../components/LoadingScreen';

const initial = { company: '', name: '', email: '', phone: '', password: '', confirm: '' };

export default function RegisterPage() {
  const [form, setForm] = useState(initial);
  const [busy, setBusy] = useState(false);
  const { authUser, loading } = useAuth();
  const { notify } = useToast();
  if (loading) return <LoadingScreen />;
  if (authUser) return <Navigate to="/" replace />;

  function update(key, value) { setForm(current => ({ ...current, [key]: value })); }
  async function submit(event) {
    event.preventDefault();
    if (form.password !== form.confirm) { notify('Passwords do not match.', 'error'); return; }
    if (form.password.length < 6) { notify('Password must be at least 6 characters.', 'error'); return; }
    setBusy(true);
    try {
      const credential = await createUserWithEmailAndPassword(auth, form.email.trim(), form.password);
      const tenantRef = doc(collection(db, 'tenants'));
      await setDoc(tenantRef, {
        id: tenantRef.id, companyName: form.company.trim(), contactName: form.name.trim(), email: form.email.trim(), phone: form.phone.trim(),
        status: 'pending_subscription', subscriptionStatus: 'inactive', maxScreens: 0, maxStorageGB: 0, createdAt: serverTimestamp()
      });
      await setDoc(doc(db, 'users', credential.user.uid), { uid: credential.user.uid, tenantId: tenantRef.id, name: form.name.trim(), email: form.email.trim(), role: 'owner', status: 'active', createdAt: serverTimestamp() });
      const groupRef = doc(collection(db, 'screen_groups'));
      await setDoc(groupRef, { tenantId: tenantRef.id, name: 'Default Group', createdAt: serverTimestamp() });
      await signOut(auth);
      notify('Account created. Sign in, then choose a subscription package to activate screens.', 'success');
    } catch (error) { notify(error.message, 'error'); }
    finally { setBusy(false); }
  }

  return (
    <div className="register-page"><div className="register-card"><div className="auth-brand center"><div className="brand-mark">WS</div><span>Weilink Signage</span></div><div className="auth-card-head"><span className="eyebrow">Create customer workspace</span><h2>Start with an account, then choose your package.</h2><p>No screen entitlement is granted until a package is activated.</p></div>
      <form onSubmit={submit} className="form-grid two-col">
        <label className="field"><span>Company name</span><input value={form.company} onChange={e => update('company', e.target.value)} required /></label>
        <label className="field"><span>Contact person</span><input value={form.name} onChange={e => update('name', e.target.value)} required /></label>
        <label className="field"><span>Email</span><input type="email" value={form.email} onChange={e => update('email', e.target.value)} required /></label>
        <label className="field"><span>Phone</span><input value={form.phone} onChange={e => update('phone', e.target.value)} required /></label>
        <label className="field"><span>Password</span><input type="password" value={form.password} onChange={e => update('password', e.target.value)} required /></label>
        <label className="field"><span>Confirm password</span><input type="password" value={form.confirm} onChange={e => update('confirm', e.target.value)} required /></label>
        <div className="form-full"><button className="btn btn-primary btn-wide" disabled={busy}>{busy ? 'Creating workspace…' : 'Create workspace'}</button></div>
      </form><p className="auth-bottom">Already have an account? <Link to="/tenant/login">Sign in</Link></p></div></div>
  );
}
